.ko{pointer-events:auto;}